<template>
<div class="add-device">
    <van-nav-bar title="更换设备" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <p>当前使用的设备IMEI:{{imei}}</p>
    <span>更换新设备</span>
    <div class="imei-input">
      <van-field
      v-model="newImei"
      placeholder="请输入新设备IMEI"
      :border="false"
      type="number"
      :maxlength="15"
      />
      <img class="device-img" src="@/assets/images/saoyisao.png" background-size="cover" @click="toCamera()" />
    </div>
    <div class="btn-box">
      <van-button round type="info" @click="binding">绑定</van-button>
    </div>
</div>
</template>

<script>
import tokenVerify from '@/utils/lib/token-verify'; //token验证
export default {
  data () {
    return {
      newImei:'',//用户输入imei
      imei:'',//用户imei
      childId:null,
    }
  },

  components: {
    
  },
  created () {
    if (this.$route.query.data) {
      this.imei = this.$route.query.data
    }
    this.newImei = this.$store.state.changeImei
  },
  methods: {
    //跳转扫码页面
    toCamera(){
      if(/android/i.test(navigator.userAgent)){
        this.$router.push({ name: 'myCamera', query: { 'data': true }});
      }
      if(/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)){
        this.$router.push({ name: 'myCamera1', query: { 'data': true }});
      }
    },
    //绑定imei
    binding(){
      let data = {
        ver:1,
        method:'changeImei',
        newImei:this.newImei
      }
      this.$http.post(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            tokenVerify(res.data.token)
            this.$router.push({ name: "location" });
            this.$store.commit('set_changeImei', '');
            // window.location.href = res.data
          } else{
            this.$toast({
                message: res.msg,
                duration: 2000,
                icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
    /**
     * 返回上一级
     */
    backPage() {
        this.$router.back(-1);
    },
  },
  watch: {
    '$store.state.changeImei':function(now,old){
      this.newImei = now
    },
  },
}
</script>

<style lang="scss" scoped>
.add-device{
  padding: 120px 40px 0;
  >p {
    font-size: 28px;
    color: #999;
    margin: 0 0 20px 10px;
  }
  >span{
    font-size: 34px;
    color: #999;
    margin-left: 10px;
  }
  .imei-input{
    display: flex;
    border: 1px solid #ccc;
    overflow: hidden;
    width: 650px;
    border-radius: 20px;
    padding-right: 15px;
    align-items: center;
    margin: 40px auto 0;
    .device-img{
      width: 80px;
      height: 60px;
    }
  }
}
.btn-box{
  width: 100%;
  padding: 20px 0 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
<style lang="scss">
.add-device .van-button{
  margin: 0 auto;
  border: none;
  width: 650px;
  height: 98px;
  border-radius: 20px;
  background-color: #01ADA9;
}

</style>
